import { Component, OnInit, NgZone } from '@angular/core';
import { UtilService } from 'src/app/services/util.service';
import { Router } from '@angular/router';;
import { DBService } from 'src/app/services/db.service';
import { STORAGE_REMIND_OPEN_RESTAURANT, STORAGE_INFORM_ABOUT_ORDER_VIA_PUSH, STORAGE_PUSH_ANALYTICS } from 'src/environments/constant';
import { TOPIC_RESTAURANT_REMIND_OPENING, PushService, TOPIC_RESTAURANT_IS_OPENING, TOPIC_NEW_ORDER, TOPIC_ANALYTICS } from 'src/app/services/push.service';
import { ImageService } from 'src/app/services/image.service';

import { STORAGE_PUSH_SUBSCRIPTIONS } from 'src/environments/environment.prod';
import { UserService } from 'src/app/services/user.service';
import { Restaurant } from 'src/app/models/restaurant.model';
import { RestaurantOptionService } from 'src/app/services/restaurant-option.service';

@Component({
  selector: 'app-local-info',
  templateUrl: './local-info.page.html',
  styleUrls: ['./local-info.page.scss'],
})
export class LocalInfoPage implements OnInit {

  orgAddress: string
  linkHost: string = "https://barela.web.app/"

  constructor(public db: DBService, public util: UtilService, private ngZone: NgZone, private router: Router,
    public imageService: ImageService, private pushService: PushService, public userService: UserService) {
    if (this.util.demo) {
      this.linkHost = "https://barela-demo.web.app/"
    }
  }

  get directLink() {
    return this.linkHost + "?restaurant=" + this.db.currentRestaurantKey
  }

  ngOnInit() {
    if (!this.db.currentRestaurantKey) {
      this.ngZone.run(() => this.router.navigate(['/restaurant-list']))
      return
    }

    this.orgAddress = this.db.currentRestaurant.address
  }

  openBasket() {
    this.ngZone.run(() => this.router.navigate(['/basket']))
  }

  changeSubscription() {
    this.userService.pushSubscription[this.db.currentRestaurantKey] = !this.userService.pushSubscription[this.db.currentRestaurantKey];
    // this.pushToogle();
  }

  /**
* Toogle, ob man Push benachrichtigungen erhalten moechte
*/
  pushToogle() {
    localStorage.setItem(STORAGE_PUSH_SUBSCRIPTIONS, JSON.stringify(this.userService.pushSubscription))

    if (this.userService.pushSubscription[this.db.currentRestaurantKey] === true) {
      this.pushService.subscribeToTopic(TOPIC_RESTAURANT_IS_OPENING, this.db.currentRestaurantKey)
    } else {
      this.pushService.unsubscribeToTopic(TOPIC_RESTAURANT_IS_OPENING, this.db.currentRestaurantKey)
    }
  }

  pushAnalyticsToogle() {
    localStorage.setItem(STORAGE_PUSH_ANALYTICS, JSON.stringify(this.userService.pushAnalytics))

    if (this.userService.pushAnalytics === true) {
      this.pushService.subscribeToTopic(TOPIC_ANALYTICS)
    } else {
      this.pushService.unsubscribeToTopic(TOPIC_ANALYTICS)
    }
  }

  reminderToOpenChanged() {
    if (this.util.remindToOpenRestaurantPersonally) {
      localStorage.setItem(STORAGE_REMIND_OPEN_RESTAURANT + "-" + this.db.currentRestaurantKey, JSON.stringify(true))
      this.pushService.subscribeToTopic(TOPIC_RESTAURANT_REMIND_OPENING, this.db.currentRestaurantKey)
    } else {
      localStorage.removeItem(STORAGE_REMIND_OPEN_RESTAURANT + "-" + this.db.currentRestaurantKey)
      this.pushService.unsubscribeToTopic(TOPIC_RESTAURANT_REMIND_OPENING, this.db.currentRestaurantKey)
    }
  }


  informAboutOrdersViaPushChanged() {
    if (this.util.informAboutOrdersViaPush) {
      localStorage.setItem(STORAGE_INFORM_ABOUT_ORDER_VIA_PUSH + "-" + this.db.currentRestaurantKey, JSON.stringify(true))
      this.pushService.subscribeToTopic(TOPIC_NEW_ORDER, this.db.currentRestaurantKey)
    } else {
      localStorage.removeItem(STORAGE_INFORM_ABOUT_ORDER_VIA_PUSH + "-" + this.db.currentRestaurantKey)
      this.pushService.unsubscribeToTopic(TOPIC_NEW_ORDER, this.db.currentRestaurantKey)
    }
  }

  changeApprovementStatus(evt) {
    this.db.currentRestaurant.isApprovedByMamingo = +evt.detail.value
  }

  clickOnLogo() {
    if (!this.util.isMobileApp2) {
      this.util.presentToast("Das Logo kann aktuell nur in der Mobile App ausgetauscht werden.")
      return
    }
    this.imageService.uploadHandler(this.db.currentRestaurantKey);
  }

  back() {
    if (!this.db.loggedUserUID || !(this.db.isOwner || this.db.isEmployee)) this.ngZone.run(() => this.router.navigate(['/customer-home']))
    else this.ngZone.run(() => this.router.navigate(['/owner-home']))
  }


  save() { 
    // RestaurantOptionService.addOptionLocation(this.db.currentRestaurant) //!!!!!!
    
    if (this.orgAddress === this.db.currentRestaurant.address) {
      this.db.updateRestaurant(this.db.currentRestaurantKey)
      this.util.presentToast("Angaben wurden gespeichert")
      this.ngZone.run(() => {
        this.db.currentPage = 'home'
        this.router.navigate(['/owner-home'])
      })
    } else {
      this.db.getGeoLocationOfRestaurant(this.db.currentRestaurant).subscribe(res => {
        //Long and Lang updated
        if (res && res.results && res.results.length > 0 && res.results[0].geometry) {
          this.db.currentRestaurant.location = res.results[0].geometry.location
        }

        this.db.updateRestaurant(this.db.currentRestaurantKey)
        this.util.presentToast("Angaben wurden gespeichert")
        this.ngZone.run(() => {
          this.db.currentPage = 'home'
          this.router.navigate(['/owner-home'])
        })
      });

    }




  }
}
